$(document).ready(() => {
  // show/hide product filters
  $("#productFiltersBtn").on("click", function() {
    $("#productFilters").slideToggle();
    $("#filtersShow, #filtersHide").toggle();
  });

  const pfgradeToggle = document.getElementById("pfgradeToggle");
  if (pfgradeToggle) {
    pfgradeToggle.addEventListener("change", function () {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      if (this.checked) {
        params.set("pfgrade", "true");
      } else {
        params.delete("pfgrade");
      }

      // Always go to page 1 when changing filters
      params.delete("page");

      // Redirect with updated query string
      url.search = params.toString();
      window.location.href = url.toString();
    });
  }



  // Grade filter multi-select functionality
  const gradeCheckboxes = document.querySelectorAll('.grade-checkbox');
  if (gradeCheckboxes.length > 0) {
    gradeCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (this.value === 'all') {
          // "All Grades" selected - clear all grade parameters
          params.delete("grade");
          // Uncheck all other grade checkboxes
          gradeCheckboxes.forEach(cb => {
            if (cb.value !== 'all') {
              cb.checked = false;
            }
          });
        } else {
          // Individual grade selected
          if (this.checked) {
            // Add this grade to the list
            params.append("grade", this.value);
            // Uncheck "All Grades"
            const allGradesCheckbox = document.getElementById('gradeAll');
            if (allGradesCheckbox) {
              allGradesCheckbox.checked = false;
            }
          } else {
            // Remove this grade from the list
            const grades = params.getAll("grade");
            const index = grades.indexOf(this.value);
            if (index > -1) {
              grades.splice(index, 1);
              params.delete("grade");
              grades.forEach(grade => params.append("grade", grade));
            }

            // If no grades selected, check "All Grades"
            if (params.getAll("grade").length === 0) {
              const allGradesCheckbox = document.getElementById('gradeAll');
              if (allGradesCheckbox) {
                allGradesCheckbox.checked = true;
              }
            }
          }
        }

        // Always go to page 1 when changing filters
        params.delete("page");

        // Redirect with updated query string
        url.search = params.toString();
        window.location.href = url.toString();
      });
    });
  }

  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-checkbox-reload]')) return
    let checkbox = e.target
    const url = new URL(window.location.href)
    if (checkbox.dataset.hasOwnProperty('checkboxReloadParams')) {
      url.search = (new URLSearchParams(checkbox.dataset.checkboxReloadParams)).toString()
    } else if (checkbox.value) {
      let valueSet = new Set(url.searchParams.getAll(checkbox.name))
      url.searchParams.delete(checkbox.name)
      if (checkbox.checked) {
        valueSet.add(checkbox.value)
      } else {
        valueSet.delete(checkbox.value)
      }
      valueSet.values().forEach(val => url.searchParams.append(checkbox.name, val))
    }

    window.location.href = url.toString()
  })
});
